/**
 * Sanitizes an address string for geocoding API calls by removing special
 * characters that may cause 400 errors.
 *
 * Keeps only alphanumeric characters, spaces, commas, periods, and hyphens,
 * which are all safe for Google's Geocoding API. Special characters like
 * pipe (|), ampersand (&), hash (#), etc. are removed.
 *
 * @param address - The address string to sanitize
 * @returns The sanitized address string
 *
 * @example
 * sanitizeAddressForGeocoding("KTGY | Washington, DC")
 * // Returns: "KTGY Washington, DC"
 *
 * @example
 * sanitizeAddressForGeocoding("123 Main St. #5A")
 * // Returns: "123 Main St. 5A"
 */
export function sanitizeAddressForGeocoding(address: string): string {
  if (!address) {
    return '';
  }

  return address
    .replace(/[^a-zA-Z0-9\s,.-]/g, '') // Keep only alphanumeric, spaces, commas, periods, and hyphens
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim(); // Remove leading/trailing whitespace
}
